import { type TokenGroup } from "../../types";

export const flash = {
  name: "flash",
  variables: {
    "1": { type: "color", value: { dark: "#170e0e", light: "#fffcfc" } },
    "2": { type: "color", value: { dark: "#211211", light: "#fff7f6" } },
    "3": { type: "color", value: { dark: "#3e0e0e", light: "#ffebe8" } },
    "4": { type: "color", value: { dark: "#56040b", light: "#ffdad5" } },
    "5": { type: "color", value: { dark: "#670a11", light: "#ffcbc5" } },
    "6": { type: "color", value: { dark: "#7a1a1d", light: "#fca59e" } },
    "7": { type: "color", value: { dark: "#942a2b", light: "#f89790" } },
    "8": { type: "color", value: { dark: "#bf383a", light: "#f58982" } },
    "9": { type: "color", value: { dark: "#e41a2f", light: "#e41a2f" } },
    "10": { type: "color", value: { dark: "#f1555c", light: "#d5001f" } },
    "11": { type: "color", value: { dark: "#ff8f88", light: "#da0026" } },
    "12": { type: "color", value: { dark: "#ffd0cb", light: "#691115" } },
  },
} as const satisfies TokenGroup<"flash">;
